import { render, staticRenderFns } from "./lobby.vue?vue&type=template&id=ddc36a96&scoped=true&"
import script from "./lobby.vue?vue&type=script&lang=js&"
export * from "./lobby.vue?vue&type=script&lang=js&"
import style0 from "./lobby.vue?vue&type=style&index=0&id=ddc36a96&prod&lang=scss&scoped=true&"
import style1 from "./lobby.vue?vue&type=style&index=1&id=ddc36a96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc36a96",
  null
  
)

export default component.exports